module.exports = __webpack_public_path__ + "fonts/GT-Eesti-Display-Regular.10e23a6.eot";